module.exports = __webpack_public_path__ + "static/windy-6b22f8e9b0b2d95e23a1007a8fb51ab5.jpg";